const CalendarSection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">📅 Lịch Học</h2>
            <p className="text-slate-700">
                Quản lý và theo dõi lịch học, deadline bài tập.
            </p>

            <div className="bg-white p-6 rounded-lg border border-slate-200">
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Các loại sự kiện:</h3>
                <div className="space-y-3">
                    <div className="p-3 bg-blue-50 border-l-4 border-blue-500">
                        <strong className="text-blue-900">📚 Lịch học:</strong>
                        <span className="text-slate-700"> Các buổi học theo thời khóa biểu</span>
                    </div>
                    <div className="p-3 bg-orange-50 border-l-4 border-orange-500">
                        <strong className="text-orange-900">📝 Deadline bài tập:</strong>
                        <span className="text-slate-700"> Hạn nộp bài kiểm tra, bài tập</span>
                    </div>
                    <div className="p-3 bg-purple-50 border-l-4 border-purple-500">
                        <strong className="text-purple-900">📅 Sự kiện:</strong>
                        <span className="text-slate-700"> Các sự kiện quan trọng do giáo viên tạo</span>
                    </div>
                </div>
            </div>

            <div className="bg-indigo-50 p-6 rounded-lg border border-indigo-200">
                <h3 className="text-lg font-semibold text-indigo-900 mb-2">✨ Tính năng</h3>
                <ul className="text-slate-700 space-y-2">
                    <li>• Xem lịch theo tháng với giao diện trực quan</li>
                    <li>• Nhấn vào ngày để xem chi tiết các sự kiện</li>
                    <li>• Tự động đồng bộ lịch học từ lớp học</li>
                    <li>• Thông báo nhắc nhở trước deadline</li>
                </ul>
            </div>
        </div>
    );
};

export default CalendarSection;
